import React from 'react';

import FieldContainer from 'components/pure/utils/form/FieldContainer';
import {KpiAssignee, KpiAssignmentId, KpiTargetId} from '@store/@types/kpi';
import SingleAutocomplete from '@components/auto-complete/SingleAutocomplete';
import KpiTargetSource from '@store/kpi/KpiTargetSource';

const INPUT_WIDTH = 400;

interface Props {
  fieldClassName: string;
  labelClassName: string;
  fullSource: typeof KpiTargetSource.assigneeAutocomplete;
  commonSource: typeof KpiTargetSource.assigneeAutocompleteCommon;
  value: KpiAssignee | undefined;
  onChange: (newValue: KpiAssignee | undefined) => void;
  hasKpiAssigned: (
    kpiId: KpiTargetId,
    assignee: KpiAssignee,
    assignmentId?: KpiAssignmentId
  ) => boolean;
  kpiId: KpiTargetId;
  assignmentId?: KpiAssignmentId;
}

export const AssignToField: React.FC<Props> = ({
  fieldClassName,
  labelClassName,
  fullSource,
  commonSource,
  value,
  onChange,
  hasKpiAssigned,
  kpiId,
  assignmentId,
}) => {
  return (
    <FieldContainer className={fieldClassName} labelClassName={labelClassName} label="Assign to">
      <SingleAutocomplete
        fullSource={fullSource}
        commonSource={commonSource}
        setValue={onChange}
        value={value}
        getLabel={v => v.name}
        getGroup={v => v.type}
        placeholder="Choose user, team, department or job..."
        previewLabel={(resultSize, total) =>
          `Showing ${resultSize}/${total} potential values. Type to search for a specific option`
        }
        isOptionDisabled={opt => hasKpiAssigned(kpiId, opt, assignmentId)}
        width={INPUT_WIDTH}
      />
    </FieldContainer>
  );
};
